export default {
  equip: 'Equipment',
  name1: 'Real name',
  name2: 'Please Enter real name',
  address1: 'Participant nationality',
  address2: 'Enter the nationality of participants',
  language1: 'Choose language',
  language2: 'Please choose',
  upload1: 'Upload audio',
  upload2: 'Drag files here, or',
  upload3: 'click to upload',
  upload4: ' Please upload one wav. audio once. Audio should be smaller than 500 Mb.',
  submit: 'Submit',
  reset: 'Reset',
  js: {
    rules: {
      equip: 'Please choose equipment',
      name: 'Please enter name',
      address: 'Please enter the nationality of participants',
      language: 'Please enter nationality'
    },
    error: {
      type1: 'Failure',
      type2: 'Empty',
      type3: 'File is too large',
      type4: 'Upload failure, please try again',
      type5: 'Remove'
    },
    success: {
      type1: 'Success',
      type2: 'Upload Success'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/collectWav.js